

export class LicenseToDriveUpdateInput implements ILicenseToDriveUpdateInput {
    /** The auto-generated id of the license to drive  master */
    licenseToDriveId!: number;
    /** The license to drive name with 255 character limit */
    licenseToDriveName!: string;

    constructor(data?: ILicenseToDriveUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseToDriveId = _data["licenseToDriveId"];
            this.licenseToDriveName = _data["licenseToDriveName"];
        }
    }

    static fromJS(data: any): LicenseToDriveUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseToDriveId"] = this.licenseToDriveId;
        data["licenseToDriveName"] = this.licenseToDriveName;
        return data; 
    }
}

export interface ILicenseToDriveUpdateInput {
    /** The auto-generated id of the license to drive  master */
    licenseToDriveId: number;
    /** The license to drive name with 255 character limit */
    licenseToDriveName: string;
}

